import {Pinia} from 'pinia'
import {RouteLocationNormalized} from 'vue-router'
import {ResourceType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/ResourceType'
import {ClientRouteParamType} from '@toolify/client/src/setup/router/enum/ClientRouteParamType'
import {useResourceItemApiStore} from '@toolify/client/src/stores/api/ResourceItemApiStore/useResourceItemApiStore'
import {isStackableRoute} from '@toolify/client/src/setup/router/hooks/isStackableOverlayNavigation'

export function markFolderVisitEndedRouterHookFactory(pinia: Pinia) {
  return function markFolderVisitEndedRouterHook(to: RouteLocationNormalized, from?: RouteLocationNormalized) {
    const previousFolderId = from?.params?.[ClientRouteParamType.FolderId] as string | undefined
    if(!previousFolderId || previousFolderId === to.params[ClientRouteParamType.FolderId] || isStackableRoute(to)) {
      return
    }
    useResourceItemApiStore(pinia).markResourceVisitEnded(ResourceType.Folder, previousFolderId).catch(() => undefined)
  }
}
